import React, { Component } from "react";
import { connect } from "react-redux";
import {
  FormGroup,
  ControlLabel,
  FormControl,
  OverlayTrigger,
  Tooltip,
  Col
} from "react-bootstrap";

function LinkWithTooltip({ id, children, href, tooltip }) {
  return (
    <OverlayTrigger
      overlay={<Tooltip id={id}>{tooltip}</Tooltip>}
      placement="top"
      // delayShow={300}
      delayHide={150}
    >
      <a href={href}>{children}</a>
    </OverlayTrigger>
  );
}

class HorizontalFormInputs extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }


 onChange = (event) => {
  // this.setState({title: eventKey});
  this.props.onValueChange(
    event.target.value,
    this.props.statekey,
    this.props.eth
  );
};

  render() {
    const { label, status, ncols,statekey,tooltip,hidden, ...rest } = this.props;
    let statusStyle = "";
    if (status === "disconnected") {
      statusStyle = "statusColorDisconnected";
    } else if (status === "connected") {
      statusStyle = "statusColorConnected";
    }
    var row = [];
    var style = {};
    if(hidden===true) {
      style.display = 'none';
    }

    for (var i = 0; i < ncols.length; i++) {
      row.push(
        <div key={i} className={ncols[i]}>
          <FormGroup style={{ marginBottom: -10 + "px" }}>
            <Col
              componentClass={ControlLabel}
              style={{ marginTop: 5 + "px" }}
              md={5}
            >
              {label}
            </Col>
            <Col md={7}>
              <LinkWithTooltip id={statekey} href="#" tooltip={tooltip}>
                <FormControl
                  className={statusStyle}
                  style={{ height: 25 + "px" }}
                  onChange={this.onChange}
                  {...rest}
                />
              </LinkWithTooltip>
            </Col>
          </FormGroup>
        </div>
      );
    }
    return <div style={style}>{row}</div>;
  }
}

export default HorizontalFormInputs;
